import React, { ReactNode, useEffect, useState } from 'react';
import styles from './SlidingModal.module.css';
import useSwipe from '@/hooks/utilities/useSwipe';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
type SlidingModalProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  heightFit?: boolean;
  className?: string;
};
const SlidingModal: React.FC<SlidingModalProps> = ({
  children,
  isOpen,
  onClose,
  heightFit,
  className
}) => {
  const swipeHandlers = useSwipe({
    onSwipedDown: () => {
      onClose();
    }
  });
  const touchHandlerName = useTouchHandlerName();
  return <>
      {isOpen && <div {...swipeHandlers} style={{
      zIndex: 9999
    }} className={`${styles.overlay} no-scrollbar`} {...{
      [touchHandlerName]: () => {
        onClose();
      }
    }}></div>}
      <div style={{
      zIndex: 9999
    }} className={`${styles.modal} ${heightFit ? 'no-scrollbar h-[fit-content!important] pb-[30px]' : 'h-[100px] !important] overflow-x-clip'}  ${isOpen ? styles.show : ''} ${className && className}  `}>
        <div className={`${styles.content}`}>
          <div className={styles.separator}></div>
          <div className={`pt-2 rounded-lg ${heightFit && 'mt-2'}`}>{children}</div>
        </div>
      </div>
    </>;
};
export default SlidingModal;